import React from 'react';

import {
  TransportationItemsFragment,
  useCreateTransportationItemMutation,
  useDeleteTransportationItemMutation,
  useTransportationQuery,
  useUpdateTransportationItemMutation,
} from '../../../generated/graphql';
import deletePageItem from '../../../helpers/apolloCache/deletePageItem';
import { useManageItem } from '../../../helpers/useManageItem';
import Layout from '../../FormComponents/Layout';
import { FIELDS } from '../ActivityItem';
import { PageItemProps } from '../BasicItem';
import { createSave } from '../BusinessItem/Edit';
import Form, { initialValues, validationSchema } from '../BusinessItem/Form';

export const TransportationItem: React.FC<PageItemProps> = ({ onSaveHandler }) => {
  const { pageId, itemId, isNew, close } = useManageItem();
  const [create, { loading: creating }] = useCreateTransportationItemMutation();
  const [update, { loading: updating }] = useUpdateTransportationItemMutation();
  const [destroy, { loading: deleting }] = useDeleteTransportationItemMutation();

  const { data, loading } = useTransportationQuery({
    variables: {
      pageId,
      id: itemId!,
    },
    skip: isNew,
  });

  const item = data?.page?.transportationItem;
  const save = createSave({ update, create, pageId, itemId, close, onSaveHandler, fields: FIELDS });

  const onDelete = async () => {
    if (itemId) {
      await destroy({
        variables: {
          attributes: {
            id: itemId,
            pageId,
          },
        },
        update(cache) {
          deletePageItem({ cache, pageId, itemId });
        },
      });
    }
  };

  return (
    <Layout
      headerText={`${isNew ? 'Add' : 'Update'} a Transport`}
      validationSchema={validationSchema}
      initialValues={initialValues<TransportationItemsFragment>(item)}
      onSubmit={save}
      Component={Form}
      loading={loading}
      updating={updating || deleting || creating}
      close={close}
      pageId={pageId}
      isNew={isNew}
      onDelete={onDelete}
    />
  );
};
